webpackJsonp([61897823061424],{

/***/ 1520:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProductMetadataFieldInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-product-metadata-field-input-9d7bbbf1b0603df05dbb.js